import * as React from 'react';
import { WTable } from './WTable';
import * as Moment from 'moment';


interface WTableHistoryProps extends React.ClassAttributes<any> {
    entity: string;
    data: any;
    columns: any;
}

interface WTableHistoryState {
    data: any;
    columns: any;
}

export class WTableHistory extends React.Component<WTableHistoryProps, WTableHistoryState>  {

    constructor(props: any) {
        super(props);

        this.prepareData = this.prepareData.bind(this);
        this.prepareColumns = this.prepareColumns.bind(this);

        this.state = {
            data: this.prepareData(),
            columns: this.prepareColumns()
        };
    }

    prepareColumns() {
        const col = this.props.columns;
        const col2 = [
            {
                Header: 'Info',
                columns: [
                    {
                        Header: 'Datum',
                        accessor: '-meta_datum'
                    },
                    {
                        Header: 'ID',
                        accessor: '-meta_id'
                    },
                    {
                        Header: 'User',
                        accessor: '-meta_user'
                    }
                ]
            }
        ];
        const dataCol = [];
        for (const i of Object.keys(col)) {
            if (col[i].Header !== '' && col[i].accessor !== '') {
                dataCol.push(col[i]);
            }
        }
        col2.push({
            Header: 'Datensatz',
            columns: dataCol
        });
        return col2;
    }

    prepareData() {
        const data = this.props.data;
        for (const i of Object.keys(data)) {
            data[i]['-meta_id'] = data[i].id;
            data[i]['-meta_user'] = data[i].user;
            data[i]['-meta_datum'] = Moment.unix(data[i].datum).format('DD.MM.YYYY HH:mm');
            const datei = data[i].datei;
            for (const key of Object.keys(datei)) {
                data[i][key] = datei[key];
            }
        }
        return data;
    }

    render() {
        return (
            <div>
                <WTable
                    tableId='showTableHistory'
                    entity={this.props.entity}
                    columns={this.state.columns}
                    data={this.state.data}
                    onAction={() => { }}
                    showPagination={true}
                    pageSize={15}
                />
            </div>
        );
    }
}
